import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { axiosInstance } from "../../config/https";
import { useLoader } from "../../context/LoaderContext";
import { FREELANCER } from "../../Router/paths";
import listIcon from "../../assets/images/list-icon1.png";

export default function MyJobsComp() {
  const { startLoader, stopLoader } = useLoader();
  const [jobs, setJobs] = useState([]);
  // const { openModal } = useModal();

  useEffect(() => {
    getFreelancers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getFreelancers = () => {
    startLoader();
    axiosInstance
      .get("/api/freelancer-jobposts")
      .then((resp) => {
        stopLoader();
        const Data = resp.data;
        if (resp.status === 200 || resp.status === 201) {
          setJobs(Data.data);
        } else {
          toast.warning(Data.msg);
        }
      })
      .catch(() => {
        stopLoader();
      });
  };

  // const completeJob = (id) => {
  //   startLoader();
  //   axiosInstance
  //     .put(`/api/jobposts/${id}/complete/`)
  //     .then((resp) => {
  //       stopLoader();
  //       const Data = resp.data;
  //       if (resp.status === 200 || resp.status === 201) {
  //         openModal(
  //           "thubsUp", //gif url
  //           "Job Completed Successfully!", //title
  //           "" //subtitle
  //         );
  //         getFreelancers();
  //       } else {
  //         toast.warning(Data.msg);
  //       }
  //     })
  //     .catch(() => {
  //       stopLoader();
  //     });
  // };

  return (
    <section className="my-jobs pc-p-3">
      <div className="container">
        <div className="primary-heading color-dark mb-4">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6 col-6">
              <h4>My Jobs</h4>
            </div>
            <div className="col-lg-6 col-md-6 col-6">
              <div className="text-right myjobs-header">
                <p className="mb-0">
                  Earnings available now: ${jobs?.balance}{" "}
                  <span>
                    <img src="/assets/three-dots-ico.png" alt="Three Dots" />
                  </span>
                </p>
                <ul className="jobs-submenu">
                  <li>
                    <Link to="#">Get Paid </Link>
                  </li>
                  <li>
                    <Link to="#">View pending Earnings </Link>
                  </li>
                  <li>
                    <Link to="#">Learn about Payments </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="myjob-box mb-4">
          <div className="primary-heading color-dark">
            <h5 className="mb-3">Jobs</h5>
            <p>
              Contracts you’re actively working on will appear here.{" "}
              <Link to={FREELANCER.dashboard} className="color-secondary">
                {" "}
                Start searching for new projects now
              </Link>
              !{" "}
            </p>
          </div>
        </div>
        {jobs?.job_posts?.map((e, i) => (
          <div className="freelancer-post-box" key={i}>
            <div className="row">
              <div className="col-md-8">
                <div className="d-flex justify-content-between align-items-center">
                  <h4>
                    <a>{e?.job_title}</a>
                  </h4>
                </div>
                <h5>
                  Fixed-price - {e?.experience_needed} - Est. Budget: $
                  {e?.project_budget} - Posted {e?.created_time}
                </h5>
                <p style={{ textAlign: "justify" }}>{e?.description}</p>
                <div className="tags">
                  <ul>
                    {e?.skills?.map((e) => (
                      <li key={e?.id}>{e?.name}</li>
                    ))}
                  </ul>
                </div>
                <p className="mt-3">
                  <span>Proposals:</span> {e?.numofproposals}
                </p>
                <ul className="flncr-payment-list">
                  <li>
                    {e?.verified && (
                      <>
                        <span>
                          <img src={listIcon} alt="List Icon" />
                        </span>{" "}
                        <span> Payment Verified</span>
                      </>
                    )}
                  </li>
                </ul>
              </div>
              <div className="col-md-4">
                <div className="h-100 d-flex flex-column align-items-center justify-content-center">
                  <li className="list-inline-item">
                    <Link
                      to={FREELANCER.fileAComplain(e.id)}
                      state={e}
                      className="primary-btn secondary-bg"
                    >
                      File a Complain
                    </Link>
                  </li>
                  <li className="list-inline-item">
                    {e.status === "completed" ? (
                      <button className="primary-btn secondary-bg">
                        Completed
                      </button>
                    ) : (
                      <button
                        className="primary-btn secondary-bg"
                        // onClick={() => completeJob(e.id)}
                      >
                        Complete Job
                      </button>
                    )}
                  </li>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
